import { Button, ButtonSize, ButtonVariant, Input, Text, TextVariants } from "@next-platform/client-common-spicy-ui";
import type { KeyboardEvent } from "react";

import { Col, Row } from "@/components/customComponents";
import { ANALYTICS_MIN_DATE_STR } from "@/pages/CreatorAnalytics/constants";

interface ICustomDateRangeEditorProps {
  draftFromStr: string;
  draftToStr: string;
  todayStr: string;
  isFromInvalid: boolean;
  isToInvalid: boolean;
  canApply: boolean;
  onDraftFromChange: (value: string) => void;
  onDraftToChange: (value: string) => void;
  onApply: () => void;
  onKeyDown: (event: KeyboardEvent<HTMLInputElement>) => void;
}

// TODO(igor-nextday): [NX-7407] move user-facing labels to Namespace.CreatorAnalytics i18n keys.
const FROM_LABEL = "From";
const TO_LABEL = "To";
const APPLY_LABEL = "Apply";

const CustomDateRangeEditor = ({
  draftFromStr,
  draftToStr,
  todayStr,
  isFromInvalid,
  isToInvalid,
  canApply,
  onDraftFromChange,
  onDraftToChange,
  onApply,
  onKeyDown,
}: ICustomDateRangeEditorProps) => (
  <Row className="flex-wrap items-end gap-3">
    <Col className="gap-1">
      <Text variant={TextVariants.LABEL_SMALL_REGULAR} className="text-default-500">
        {FROM_LABEL}
      </Text>
      <Input
        data-testid="DateRangeFilter-FromInput"
        type="date"
        value={draftFromStr}
        min={ANALYTICS_MIN_DATE_STR}
        max={draftToStr || todayStr}
        error={isFromInvalid}
        onChange={onDraftFromChange}
        onKeyDown={onKeyDown}
      />
    </Col>
    <Col className="gap-1">
      <Text variant={TextVariants.LABEL_SMALL_REGULAR} className="text-default-500">
        {TO_LABEL}
      </Text>
      <Input
        data-testid="DateRangeFilter-ToInput"
        type="date"
        value={draftToStr}
        min={draftFromStr || ANALYTICS_MIN_DATE_STR}
        max={todayStr}
        error={isToInvalid}
        onChange={onDraftToChange}
        onKeyDown={onKeyDown}
      />
    </Col>
    <Button
      data-testid="DateRangeFilter-ApplyButton"
      size={ButtonSize.MEDIUM}
      variant={ButtonVariant.CONTAINED}
      disabled={!canApply}
      onClick={onApply}
      aria-label="apply-date-range"
    >
      {APPLY_LABEL}
    </Button>
  </Row>
);

export default CustomDateRangeEditor;
